module.exports = __webpack_public_path__ + "img/1557614104214052865.d1bd59cb.png";